// extracted by mini-css-extract-plugin
module.exports = {"selectArrow":"ReportsStyledSelect_selectArrow__2y41y"};